onComplete(function() {
	const root = document.documentElement;
	const navbar = document.querySelector('.nav-header .navbar[data-brand]');
	const mobileMenu = document.getElementById('mobile-menu');
	const toggler = document.querySelector('.nav-header .menu-toggle');

	// The site holds two brands. The server reads this cookie to show the logo and menu of the brand
	// the visitor chose, on pages that are in neither brand's menu.
	const cookieName = (root.dataset.namespace || '') + 'brand';
	const hasChoice = document.cookie.split('; ').some(function(cookie) {
		return cookie.indexOf(cookieName + '=') === 0;
	});
	function rememberBrand(brand) {
		document.cookie = cookieName + '=' + encodeURIComponent(brand) + '; path=/; max-age=31536000; samesite=lax';
	}

	// After the first choice, browsing a brand's own pages counts as choosing that brand again.
	if (navbar && hasChoice && navbar.dataset.brandKnown === 'true') {
		rememberBrand(navbar.dataset.brand);
	}

	function setMenuOpen(open) {
		root.classList.toggle('menu-open', open);
		if (toggler) {
			toggler.setAttribute('aria-expanded', open ? 'true' : 'false');
		}
	}

	function openPanel(brand) {
		if (!mobileMenu) {
			return;
		}
		mobileMenu.querySelectorAll('.mobile-menu-panel').forEach(function(panel) {
			panel.classList.toggle('open', panel.dataset.brandPanel === brand);
		});
	}

	// Click handlers are delegated, so they keep working after the editor reloads partials.
	document.addEventListener('click', function(event) {
		const brandLink = event.target.closest('[data-brand-link]');
		if (brandLink) {
			rememberBrand(brandLink.dataset.brandLink);
		}

		if (event.target.closest('.nav-header .menu-toggle')) {
			setMenuOpen(!root.classList.contains('menu-open'));
			return;
		}

		const choice = event.target.closest('.mobile-menu-choice');
		if (choice) {
			rememberBrand(choice.dataset.brandPanel);
			openPanel(choice.dataset.brandPanel);
			return;
		}

		if (event.target.closest('.mobile-menu-back')) {
			openPanel(null);
		}
	});

	// On wider screens all overview cards of a collection share the height of the tallest card, so
	// the rows line up. Infinite scrolling adds cards later, hence the observer.
	const cardGrids = '.blog-collection-items .row, .blog-related-feed > .row, .blog-template-classic .blog-collection .row';
	function equalCards() {
		document.querySelectorAll(cardGrids).forEach(function(grid) {
			const cards = Array.from(grid.querySelectorAll('.blog-item-preview'));
			cards.forEach(function(card) {
				card.style.minHeight = '';
			});
			if (window.innerWidth < 768 || cards.length < 2) {
				return;
			}
			const tallest = Math.max.apply(null, cards.map(function(card) {
				return card.offsetHeight;
			}));
			cards.forEach(function(card) {
				card.style.minHeight = tallest + 'px';
			});
		});
	}
	equalCards();
	window.addEventListener('resize', equalCards);
	window.addEventListener('load', equalCards);
	document.querySelectorAll(cardGrids).forEach(function(grid) {
		new MutationObserver(equalCards).observe(grid, { childList: true });
	});

	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && root.classList.contains('menu-open')) {
			setMenuOpen(false);
		}
	});
});
